<div class="container">
  <mat-card>
    <form [formGroup]="periodicAccrualsForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div class="layout-row">
          <mat-form-field class="flex-fill" (click)="tillDatePicker.open()">
            <mat-label>{{ 'labels.inputs.Accrue Till Date' | translate }}</mat-label>
            <input
              matInput
              [min]="minDate"
              [max]="maxDate"
              [matDatepicker]="tillDatePicker"
              required
              formControlName="tillDate"
            />
            <mat-datepicker-toggle matSuffix [for]="tillDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #tillDatePicker></mat-datepicker>
            @if (periodicAccrualsForm.controls.tillDate.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Accrue Date' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="!periodicAccrualsForm.valid"
          *LOSxHasPermission="'EXECUTE_PERIODICACCRUALACCOUNTING'"
        >
          <fa-icon icon="play" class="m-r-10"></fa-icon>
          {{ 'labels.buttons.Run Periodic Accruals' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
